import styled, { css } from "styled-components";
import { theme } from "../../styles/theme";

interface InputWrapperProps {
  $theme: string;
  $variant: string;
  $message?: string;
}

interface StyledInputProps {
  $hasIcon?: boolean;
}

export const InputWrapper = styled.div<InputWrapperProps>`
  position: relative;

  ${({ $theme }) =>
    $theme === "modern" &&
    css`
      input {
        appearance: active;
        display: block;
        background: #ffffff;
        border: 1px solid #d2d3e5;
        box-sizing: border-box;
        border-radius: 8px;
        width: 100%;
        padding: 0.75rem;
        font-size: 1rem;
        border-radius: 8px;
        padding-right: 2.5rem;
        padding-left: 2rem;
        color: #1f2937;
        transition: all 0.3s ease;

        &:focus {
          border-color: ${theme.colors.primary};
          outline: none;
          background-color: #fffbf7;
          box-shadow: 0 0 0 3px rgba(236, 103, 38, 0.1);
        }

        &:focus-visible {
          outline: none;
        }

        &:hover {
          border-color: ${theme.colors.primary};
        }

        &:disabled {
          background-color: #f5f5f5;
          cursor: not-allowed;
        }
      }
    `}

  ${({ $theme }) =>
    $theme === "legacy" &&
    css`
        input {
          appearance: active;
          display: block;
          background: #ffffff;
          border: 1px solid #d2d3e5;
          box-sizing: border-box;
          border-radius: 8px;
          margin-top: 5px;
          padding: 1rem 1.75rem;
          width: 100%;
          transition: all 0.3s ease;

          &:focus {
            border-color: ${theme.colors.primary};
            outline: none;
            background-color: #fffbf7;
            box-shadow: 0 0 0 3px rgba(236, 103, 38, 0.1);
          }

          &:focus-visible {
            outline: none;
          }

          &:hover {
            border-color: ${theme.colors.primary};
          }

          &:disabled {
            background-color: #f5f5f5;
            cursor: not-allowed;
          }
    `}
`;

export const StyledLabel = styled.label`
  display: block;
  min-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export const StyledInput = styled.input<StyledInputProps>`
 width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  border-radius: 8px;
  padding-right: 2.5rem; 
  color: #1f2937;
  outline: none;
  padding-left: ${({ $hasIcon }) => ($hasIcon ? "2rem" : ".5rem")};

  &[type="date"] {
    cursor: pointer;
  }
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 8px;
  transform: translateY(-50%);
  pointer-events: none;
  display: flex;
  align-items: center;
`;

export const ErrorMessage = styled.span`
  font-size: 12px;
  position: absolute;
  left: 0;
  top: 100%;
  color: red;
  margin-top: 0.25rem;
`;
